import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    employer: {},
    employerOriginal: null,
    employers: [],
    employerErrors: null,
    employerFilters: null,
    employerPermissions: [],
    employerShedule: [],
    employerScheduleType: [],
    hrEmployers: [],
    employerStatuses: [],
    employerStates: [],
    huntingResources: [],
    resources: [],
    employersCounter: 0,
    employerServices: [],
    serviceEmployer: {},
    serviceEmployers: [],
    isLoadingServiceEmployers: false,
    serviceWorkerFilterValue: null,
    workPlaces: [],
    employersBrands: [],
    employersLoadedAtLeastOnce: false,
    documentTypes: [],
    employerDocument: null,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
